import { InferenceAPI } from '@/services/utils'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'

export const useOrgRedirect = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: async () => {
      const userOrgs = await InferenceAPI.getUserOrgs()
      if (!userOrgs.orgs || userOrgs.orgs.length === 0) {
        throw new Error('No organizations found for the user')
      }

      const isPublicSignupEnabled =
        import.meta.env.VITE_ENABLE_PUBLIC_SIGNUP === 'true'

      // Filter out default organizations if public signup is disabled
      const filteredOrgs = isPublicSignupEnabled
        ? userOrgs.orgs
        : userOrgs.orgs.filter((org) => !org.org?.is_default_org)

      if (filteredOrgs.length === 0) {
        throw new Error('No accessible organizations found for the user')
      }

      // Check for last accessed org ID in localStorage
      const lastAccessedOrgId = localStorage.getItem('lastAccessedOrgId')
      let selectedOrg = filteredOrgs[0] // Default to first org

      // If we have a stored org ID, try to find it in the available orgs
      if (lastAccessedOrgId) {
        const foundOrg = filteredOrgs.find(
          (org) => org.org.org_id?.toString() === lastAccessedOrgId
        )
        if (foundOrg) {
          selectedOrg = foundOrg
        }
      }

      if (!selectedOrg.org.org_id) {
        throw new Error('No organizations found for the user')
      }

      // navigate
      navigate({
        to: '/$orgId/dashboard/home',
        params: {
          orgId: selectedOrg.org.org_id.toString(),
        },
      })
    },
  })
}
